// TODO - remove lint disable when editing this file
/* eslint-disable */

import { ToHTMLConverterMiddlewareManager } from './middlewareManager'

import { BLOCK_TYPE, getEntityRanges } from 'draft-js-utils'

import { Entity } from 'draft-js'

const BREAK = '<br/>'

function getTags(blockType) {
  switch (blockType) {
    case BLOCK_TYPE.HEADER_ONE:
      return ['h1']
    case BLOCK_TYPE.HEADER_TWO:
      return ['h2']
    case BLOCK_TYPE.HEADER_THREE:
      return ['h3']
    case BLOCK_TYPE.HEADER_FOUR:
      return ['h4']
    case BLOCK_TYPE.HEADER_FIVE:
      return ['h5']
    case BLOCK_TYPE.HEADER_SIX:
      return ['h6']
    case BLOCK_TYPE.UNORDERED_LIST_ITEM:
    case BLOCK_TYPE.ORDERED_LIST_ITEM:
      return ['li']
    case BLOCK_TYPE.BLOCKQUOTE:
      return ['blockquote']
    case BLOCK_TYPE.CODE:
      return ['pre', 'code']
    default:
      return []
  }
}

function writeStartTag(blockType, output) {
  let tags = getTags(blockType)
  for (let tag of tags) {
    output.push(`<${tag}>`)
  }
}

function writeEndTag(blockType, output) {
  let tags = getTags(blockType)
  if (tags.length === 1) {
    output.push(`</${tags[0]}>`)
  } else {
    let outTags = []
    for (let tag of tags) {
      outTags.unshift(`</${tag}>`)
    }
    output.push(outTags.join(''))
  }
}

function encodeContent(text) {
  return text
    .split('&')
    .join('&amp;')
    .split('<')
    .join('&lt;')
    .split('>')
    .join('&gt;')
    .split('\xA0')
    .join('&nbsp;')
    .split('\n')
    .join(BREAK + '\n')
}

function renderBlockContent(block, middleware) {
  let text = block.getText()
  if (text === '') {
    return BREAK
  }

  const charMetaList = block.getCharacterList()
  const entityPieces = getEntityRanges(text, charMetaList)
  return entityPieces
    .map(([entityKey, stylePieces]) => {
      let content = stylePieces
        .map(([text, style]) =>
          middleware.processStyles(encodeContent(text), style, block)
        )
        .join('')
      content = middleware.endStyles(content)
      const entity = entityKey ? Entity.get(entityKey) : null
      if (!entity) {
        return content
      }

      return middleware.processEntities(content, entity)
    })
    .join('')
}

export function blockToHTML(block, middleware, skipWrappingTag = false) {
  const output = []
  const blockType = block.getType()
  if (!skipWrappingTag) {
    writeStartTag(blockType, output)
  }
  output.push(renderBlockContent(block, middleware))
  if (!skipWrappingTag) {
    writeEndTag(blockType, output)
  }
  return output.join('')
}
